import { insightsApi1 } from '@subaio/api-specs'

import { asContainer } from 'lib/container'

import { OpenApi } from 'components/OpenApi'

type State = {}

export const container = asContainer<State>()({
	path: '/apis/insights/v1',
	title: 'User Insights API',
	authentication: { type: 'public' },
	Running: ({ statuspageApi }) => <OpenApi apiDocument={insightsApi1} statuspageApi={statuspageApi} />,
})
